const errorArchivo = 'No fue posible rescatar sus documentos subidos, intente más tarde';

async function getUrlArchivo(filename) {
  const response = await fetch(`${process.env.VUE_APP_SERVER_HOST}/archivos/obtener-url`, {
    method: 'POST',
    redirect: 'manual',
    headers: {
      'Authorization': `Bearer ${window.localStorage.getItem('token')}`,
      'Content-Type': 'application/json'},
    body: JSON.stringify({filename})
  });

  if (response.status !== 200) {
    if (response.status === 0) {
      window.onbeforeunload = null;
      window.location.reload();
    }
    throw Error(errorArchivo);
  }
  const resp = response ? await response.json() : null;
  if (resp.errorControlado != null) {
    throw Error(resp.errorControlado);
  }
  return {url:resp.data.url};
}

async function getAllURLsArchivos(archivos) {
  let resp = null;
  if (archivos) {
    let response = null;

    try {
      response = await fetch(`${process.env.VUE_APP_SERVER_HOST}/archivos/obtener-urls-archivos`, {
        method: 'POST',
        redirect: 'manual',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({archivos})
      });

      if (response.status !== 200) {
        if (response.status === 0) {
          window.onbeforeunload = null;
          window.location.reload();
        }
        throw Error(`Error response status ${response.status}`);
      }
    } catch (error) {
      throw Error(errorArchivo);
    }
    resp = response ? await response.json() : null;

    if (resp.errorControlado != null) {
      throw Error(resp.errorControlado);
    }
  }
  return resp.data;
}

async function getMinioPutURL(extension, proceso, tipoDocumento) {
  let resp = null;
  let response = null;
  try {
    response = await fetch(`${process.env.VUE_APP_SERVER_HOST}/archivos/subir-archivo`, {
      method: 'POST',
      redirect: 'manual',
      headers: {
        'Authorization': `Bearer ${window.localStorage.getItem('token')}`,
        'Content-Type': 'application/json'},
      body: JSON.stringify({extension, proceso, tipoDocumento })
    });

    if (response.status !== 200) {
      if (response.status === 0) {
        window.onbeforeunload = null;
        window.location.reload();
      }
      throw Error(`Error response status ${response.status}`);
    }
  } catch (error) {
    throw Error(errorArchivo);
  }
  resp = response ? await response.json() : null;
  if (resp.errorControlado != null) {
    throw Error(resp.errorControlado);
  }
  return {putUrl: resp.data.putUrl, filename: resp.data.filename};
}

async function getGtoken(key, action) {
  return new Promise(resolve => {
    window.grecaptcha.ready(function() {
      window.grecaptcha.execute(key, {action}).then(token => resolve(token));
    });
  });
}

module.exports = {
  getUrlArchivo,
  getAllURLsArchivos,
  getMinioPutURL,
  getGtoken
};
